/* eslint-disable promise/param-names */
import axios from 'axios';
import moment from 'moment';

const state = {
  token: localStorage.getItem("user-token") || "",
  user: {},
  status: "",
  errorMessage: "",
  hasLoadedOnce: false,
  accountStatus: "",
  // features efetivas resolvidas pelo backend (GET /me/features).
  // Espelha a logica do middleware requireFeature. UI usa pra esconder
  // menus / redirecionar — mas backend continua sendo a trava real.
  features: null,
};

const getters = {
  isAuthenticated: state => !!state.token,
  isManagement: state => state.user && state.user.email === 'admin@admin.com',
  accountStatus: state => state.accountStatus,
  authStatus: state => state.status,
  authErrorMessage: stage => state.errorMessage || "Erro desconhecido",
  sessionUser: state => state.user,
  userFeatures: state => state.features || {},
  hasFeature: state => name => {
    // Management bypassa qualquer gate (espelha o backend).
    if (state.user && state.user.email === 'admin@admin.com') return true;
    // Se features ainda nao carregaram, nao bloquear (evita flicker).
    // O backend continua sendo a trava real se houver tentativa de chamada.
    if (!state.features) return true;
    return state.features[name] === true;
  },
  isOnFirstSevenDays: state => {
    const userCreatedAt = state.user.createdAt;
    return moment(userCreatedAt).isAfter(moment().subtract(7, 'days'));
  },
  remainingDays: state => {
    const userCreatedAt = state.user.createdAt;
    const remainingDays = moment(userCreatedAt).add(7, 'days').diff(moment(), 'days');
    return remainingDays;
  },
  // token: state => state.token
};

const actions = {
  SESSION_RESTORE: async ({ commit, dispatch, rootState }) => {
    // console.log('Restaura a sessão c/', rootState.auth.token);
    commit('TOKEN', rootState.auth.token);
    commit('AUTH_REQUEST');
    try {
      const response = await axios.get('/users/self');
      commit('AUTH_SUCCESS', {
        user: { ...response.data.user, accountStatus: response.data.accountStatus },
        token: rootState.auth.token,
        accountStatus: response.data.accountStatus
      });
      // Carrega features em paralelo — nao bloqueia o login se falhar.
      dispatch('LOAD_FEATURES');
    } catch (e) {
      commit('AUTH_ERROR');

      dispatch('LOGOUT'); // Deslogar caso erro 401 - Forbidden
    }
  },
  AUTHENTICATE: async ({ commit, dispatch }, user) => {
    commit('AUTH_REQUEST');
    try {
      const response = await axios.post('/auth/login', user);
      if (response.isAxiosError) throw response;
      commit('TOKEN', response.data?.token);
      commit('AUTH_SUCCESS', response.data);
      dispatch('LOAD_FEATURES');
    } catch (e) {
      commit('AUTH_ERROR',e);
      dispatch('LOGOUT'); // Deslogar caso erro 401 - Forbidden
      return Promise.reject(e);
    }
  },
  LOAD_FEATURES: async ({ commit }) => {
    try {
      const response = await axios.get('/me/features');
      commit('SET_FEATURES', response.data.features || {});
    } catch (e) {
      // Falha defensiva: nao trava UI. Backend continua sendo trava real.
      console.warn('Falha ao carregar /me/features — UI segue sem bloqueio local', e?.message);
      commit('SET_FEATURES', null);
    }
  },
  REGISTER: async ({ commit, dispatch }, user) => {
    commit('AUTH_REQUEST');
    try {
      const response = await axios.post('/auth/register', user);
      commit('TOKEN', response.data.token);
      commit('AUTH_SUCCESS', response.data);
      return response.data;
    } catch (e) {
      commit('AUTH_ERROR',e);
      return Promise.reject(e);
    }
  },
  LOGOUT: ({ commit }) => {
    return new Promise(resolve => {
      commit('AUTH_LOGOUT');
      localStorage.removeItem("user-token");
      resolve();
    });
  }
};

const mutations = {
  AUTH_REQUEST: state => {
    state.status = "loading";
  },
  AUTH_SUCCESS: (state, resp) => {
    state.status = "success";
    state.token = resp.token;
    state.user = resp.user;
    state.hasLoadedOnce = true;
    state.accountStatus = resp.accountStatus;
  },
  AUTH_ERROR: (state, error) => {
    console.log(error)
    state.errorMessage = error && error.response && error.response.data && error.response.data.errorMessage;
    localStorage.removeItem("user-token");
    state.status = "error";
    state.hasLoadedOnce = true;
  },
  AUTH_LOGOUT: state => {
    state.token = "";
    state.features = null;
  },
  SET_FEATURES: (state, features) => {
    state.features = features;
  },
  TOKEN: (state, token) => {
    localStorage.setItem("user-token", token);
    state.token = token;
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
